/**
 * @generated SignedSource<<b3dbd7c6bb0d30d2d98fa4a2705702ff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type RoutineOccasionStatus = "COMPLETED" | "FUTURE" | "IN_PROGRESS" | "IN_PROGRESS_EXPIRED" | "NOT_COMPLETED" | "NOT_COMPLETED_STARTED" | "NO_TASKS_COMPLETED" | "REQUIRED_COMPLETED";
import { FragmentRefs } from "relay-runtime";
export type RoutineOccasionFollowupColumn_RoutineOccasion$data = {
  readonly endAt: string;
  readonly id: string;
  readonly occasionSections: ReadonlyArray<{
    readonly id: string;
    readonly section: {
      readonly id: string;
    };
    readonly taskExecutions: ReadonlyArray<{
      readonly id: string;
      readonly task: {
        readonly id: string;
      };
      readonly " $fragmentSpreads": FragmentRefs<"RoutineOccasionFollowupResultCell_taskExecution">;
    }>;
  }>;
  readonly startAt: string;
  readonly status: RoutineOccasionStatus;
  readonly " $fragmentType": "RoutineOccasionFollowupColumn_RoutineOccasion";
};
export type RoutineOccasionFollowupColumn_RoutineOccasion$key = {
  readonly " $data"?: RoutineOccasionFollowupColumn_RoutineOccasion$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoutineOccasionFollowupColumn_RoutineOccasion">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoutineOccasionFollowupColumn_RoutineOccasion",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RoutineOccasionSection",
      "kind": "LinkedField",
      "name": "occasionSections",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "RoutineSection",
          "kind": "LinkedField",
          "name": "section",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "taskExecutions",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "task",
              "plural": false,
              "selections": (v1/*: any*/),
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "RoutineOccasionFollowupResultCell_taskExecution"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RoutineOccasion",
  "abstractKey": null
};
})();

(node as any).hash = "f4d2a08345a5a59aa7174011a078b45d";

export default node;
